import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import Global from './store/global-selectors';
import { UserPermissionService } from './services/user-permission-service';

export const RoleBasedNavLink = ({
  activeClassName = '',
  activeStyle = null,
  className = '',
  children,
  exact = false,
  innerRef = null,
  isActive = null,
  replace = false,
  requiredPermissionRole = null,
  strict = false,
  to,
}) => {
  const userRoles = useSelector(Global.selectUseruserRoles);
  const hasAccess = UserPermissionService.userIsInRoleOrHasAdministrationPermission(userRoles, requiredPermissionRole);
  if (!hasAccess) {
    return null;
  }
  return (
    <NavLink
      activeClassName={activeClassName}
      activeStyle={activeStyle}
      className={className}
      exact={exact}
      innerRef={innerRef}
      isActive={isActive}
      replace={replace}
      strict={strict}
      tabIndex={-1}
      to={to}
    >
      {children}
    </NavLink>
  );
};

RoleBasedNavLink.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]).isRequired,
  replace: PropTypes.bool,
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.instanceOf(Element) })]),
  activeClassName: PropTypes.string,
  className: PropTypes.string,
  activeStyle: PropTypes.object,
  exact: PropTypes.bool,
  strict: PropTypes.bool,
  isActive: PropTypes.func,
  children: PropTypes.node.isRequired,
  requiredPermissionRole: PropTypes.string,
};
